import React, { useEffect, useState } from 'react';
import BRScrim from '../../assets/dsgov/js/components/scrim';
import { parseProps, componentIdGenerator } from './@uteis';
import '../../assets/dsgov/css/components/scrim.css';

const Scrim = (_props) => {
  const props = parseProps(_props);
  const [componentId] = useState(
    `scrim${componentIdGenerator()}`,
  );
  useEffect(() => {
    const component = new BRScrim('br-scrim', window.document.querySelector(`.${componentId}`));
    component.showScrim();
  }, [props.children]);

  const classes = `br-scrim ${componentId} ${props.classes}`;
  return (

    <div
      className={classes}
      onClick={props.onClick}
      onKeyUp={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      tabIndex="0"
    >
      <div className="scrim-text">
        {props.children}
      </div>

    </div>

  );
};

export default Scrim;
